export const VIDEO_FRAMES_PER_SECOND = 25;
